# import './definition.js.coffee';# Added by Script 
Namespace 'Customer.ConversationAttribute'


class Customer.ConversationAttribute.Definition extends Backbone.Model

  initialize: ->
    @errors = []

  isFilled: (conversationAttributeValue) =>
    @_getType().isFilled(conversationAttributeValue)

  isValid: (conversationAttributeValue) =>
    @_getType().isValid(conversationAttributeValue)

  getErrors: =>
    @errors

  clearErrors: =>
    @errors = []

  addError: (error) =>
    @errors.push(error)

  _getType: =>
    new Customer.ConversationAttribute.Definition[@get('attribute_type_name')](@)



class Customer.ConversationAttribute.Definition.Type extends Backbone.Model

  initialize: (@definition) ->
    # Nothing to do

  isFilled: (conversationAttributeValue) =>
    @_clearErrors()
    @_isFilled(conversationAttributeValue)

  isValid: (conversationAttributeValue) =>
    @_clearErrors()
    @_isValid(conversationAttributeValue)

  _isFilled: (conversationAttributeValue) ->
    if _.isArray(conversationAttributeValue)
      !!conversationAttributeValue.length
    else
      !!conversationAttributeValue

  _isValid: (conversationAttributeValue) ->
    true

  _clearErrors: =>
    @definition.clearErrors()

  _addError: (error) =>
    @definition.addError(error)


class Customer.ConversationAttribute.Definition.HierarchicalTags extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (values) =>
    singleValue = _.first(values)
    singleValue = singleValue.value if _.has(singleValue, "value")
    _.isArray(singleValue) &&
      singleValue.length &&
      @_areChoosable(singleValue)

  _isValid: (paths) =>
    singleValue = _.first(paths)
    return true if _.isEmpty(singleValue)
    _.every(singleValue.value || [], (path) =>
      _.isEmpty(path) || @_isChoosable(path)
    )

  _areChoosable: (paths) =>
    _.every(paths, @_isChoosable)

  _isChoosable: (tagCode) =>
    tagCode = if _.isArray(tagCode) then _.last(tagCode) else tagCode
    chosen = @_chosenTag(tagCode)
    valid = chosen && chosen.choosable
    unless valid
      @_addError(
        I18n.t('monitoring.conversation_attributes.errors.hierarchical_tags.unchoosable_tag_chosen')
      )
    valid

  _chosenTag: (tagCode) =>
    [path..., lastStep] = (
      new AccountSettings.ConversationAttributes.HierarchicalTagCollection(@_tags())
    ).codePathTo(tagCode)
    @_findTagWithCode(_.reduce(path, @_step, @_tags()), lastStep)

  _tags: =>
    @definition.get('hierarchical_tags').tags

  _step: (tags, code) =>
    @_findTagWithCode(tags, code)?.children || []

  _findTagWithCode: (tags, code) ->
    tags.find((tag) -> tag.code == code)



class Customer.ConversationAttribute.Definition.FixedString extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    _.isArray(value) && !!value.length

  _isText: ->
    true


class Customer.ConversationAttribute.Definition.FreeText extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    if _.isArray(value)
      !!value.length
    else
      !!value

  _isText: ->
    true

class Customer.ConversationAttribute.Definition.SingleLineText extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    if _.isArray(value)
      !!value.length
    else
      !!value

  _isText: ->
    true

class Customer.ConversationAttribute.Definition.Email extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    if _.isArray(value)
      !!value.length
    else
      !!value

  _isText: ->
    true

class Customer.ConversationAttribute.Definition.Boolean extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    !_.isNil(value)

  _isText: ->
    false

class Customer.ConversationAttribute.Definition.Date extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    !_.isNil(value)

  _isText: ->
    false


class Customer.ConversationAttribute.Definition.Integer extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    _.isNumber(value)

  _isText: ->
    false



class Customer.ConversationAttribute.Definition.Decimal extends  Customer.ConversationAttribute.Definition.Type

  _isFilled: (value) ->
    _.isNumber(value)
